import { AuthStateType } from "../../UserReducer"
import { ActionType } from "../../Actions"
import { INIT_TOKEN } from "../../Actions/Auth/initTokenAction"

export default function initTokenReducer (state: AuthStateType, action: ActionType) {

    if (action?.type === INIT_TOKEN){
        return {
            ...state,
            token: action.payload.accessToken,
            tokens: action.payload
        }
    }

    return state;
}